import { useArticleCategoryRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetArticleCategoryCommonInfoQuery } from "../../features/articles/articlesSlice";

export { useArticleCategoryRoutes };

export default GetDefaultIndex({ title: "گروه‌های مقالات", query: useGetArticleCategoryCommonInfoQuery });
